

// Line Item Properties (LIP) を収集する関数
const getCurrentLineItemProperties = () => {
    const properties = {};
    const propertiesInputs = document.querySelectorAll('[name^="properties["]');
    
    if (propertiesInputs && propertiesInputs.length > 0) {
        propertiesInputs.forEach(element => {
            // ラジオボタンやチェックボックスの場合、選択されていなければスキップ
            if (element.type === 'radio' || element.type === 'checkbox') {
                if (!element.checked || element.value === '') return;
            }
            // 値が空であればスキップ
            if (element.value === '') return;

            // properties[カスタムフィールド名] = 値 の形で追加
            const key = element.name.replace(/^properties\[/, '').replace(/\]$/, '');
            properties[key] = element.value;
            console.log(`プロパティ取得: ${key} = ${element.value}`);
        });
    } else {
        console.log("プロパティ入力フィールドが見つかりませんでした。");
    }
    return properties;
};

// カートに商品を追加する処理
document.addEventListener('DOMContentLoaded', function() {
    console.log("DOMが読み込まれました。カートボタンの監視を開始します。");

    let clicked = false; // ボタンが複数回押されるのを防ぐフラグ
    const addToCartButton = document.querySelector('button.button.alt');

    if (addToCartButton) {
        addToCartButton.addEventListener('click', function(event) {
            console.log("カートボタンがクリックされました。");

            if (clicked) {
                console.log("ボタンはすでにクリックされています。処理を中止します。");
                return;
            }

            clicked = true;

            // LIP（Line Item Properties）を取得
            const properties = getCurrentLineItemProperties();
            console.log("取得したプロパティ: ", properties);

            // product.selected_variant を取得
            const variantSelect = document.querySelector('select[name="id"]');
            const selectedVariant = variantSelect ? variantSelect.value : null;

            if (!selectedVariant) {
                console.error("バリアントが選択されていません。処理を中止します。");
                return;
            }

            // カートに送信するデータを作成
            const egiftFormData = {
                "items": [{
                    "id": selectedVariant,  // バリアントID
                    "quantity": 1,         // 数量
                    "properties": properties // Line Item Properties
                }]
            };

            console.log("プロパティを含む送信データ: ", JSON.stringify(egiftFormData));

            // カートにリクエストを送信
            fetch('/cart/add.js', { 
                method: 'POST', 
                headers: { 
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(egiftFormData)
            })
            .then(response => {
                console.log('Fetch response status:', response.status);
                if (response.ok) {
                    console.log('カートに正常に追加されました。カートページにリダイレクトします。');
                    // 成功した場合、カートページにリダイレクト
                    document.location = "/cart";
                } else {
                    console.error('エラー: カート追加に失敗しました。', response);
                    return response.json();
                }
            })
            .then(data => {
                console.log('レスポンスデータ:', data);
            })
            .catch((error) => {
                console.error('Fetch リクエスト中のエラー:', error);
            });
        });
    } else {
        console.log("カートボタンが見つかりませんでした。");
    }
});
